import DescriptionsExtraSnippet from "snippets/descriptions-extra.mdx";
import VisualHierarchySnippet from "snippets/visual-hierarchy.mdx";
import * as React from 'react';
export default {
  DescriptionsExtraSnippet,
  VisualHierarchySnippet,
  React
};